import {FC} from "react";
import {CalendarEvent, CalendarType} from "../../../../types/domain.ts";
import {Badge, BadgeProps, Descriptions, Flex, Popover, theme, Typography} from "antd";
import styles from './EventCalendarItem.module.css';
import {getEventTime} from "../../../../utils/getEventTIme.ts";
import {useNavigate} from "react-router";
import {FileDoneOutlined} from "@ant-design/icons";

type Props = {
    items: CalendarEvent[];
}

const STATUS_MAP: Record<CalendarType, BadgeProps['status']> = {
    'draft': 'default',
    'processing': 'warning',
    'awaits_own_approval': 'processing',
    'approved': 'success',
    'cancelled': 'error',
    'returned': 'error'
}

const STATUS_TEXT_MAP: Record<CalendarType, string> = {
    'draft': 'Черновик',
    'processing': 'В обработке',
    'awaits_own_approval': 'Ожидается ваше согласование',
    'approved': 'Согласовано',
    'cancelled': 'Отменено',
    'returned': 'Возвращено'
}

export const EventCalendarItem: FC<Props> = ({ items }) => {
    const navigate = useNavigate();
    const { token } = theme.useToken();

    return (
        <Flex vertical className={styles.container}>
            {items.map((item) => {
                const [start, end] = getEventTime(item);

                const content = (
                    <div className={styles.contentContainer}>
                        <Typography.Text strong>{item.name}</Typography.Text>
                        <Descriptions
                            className={styles.descriptions}
                            column={1}
                            items={[
                                { label: 'Время', children: `${start ? start.format('HH:mm') : '**:**'}Z - ${end ? end.format('HH:mm') : '**:**'}Z` },
                                { label: 'Статус', children: STATUS_TEXT_MAP[item.calendar_type] },
                                { label: 'VATSIM', children: item.vatsim_published ? 'Отправлено' : 'Не отправлено' }
                            ]}
                        />
                    </div>
                )

                return (
                    <Popover content={content}>
                        <Badge
                            className={styles.badge}
                            key={item.id}
                            status={STATUS_MAP[item.calendar_type]}
                            text={(
                                <Flex gap={4} className={styles.container}>
                                    <Typography.Text className={styles.itemText} ellipsis>
                                        {item.name}
                                    </Typography.Text>
                                    {item.vatsim_published && <FileDoneOutlined style={{ color: token.colorTextSecondary }} />}
                                </Flex>
                            )}
                            onClick={item.accessible ? () => navigate(`/events/${item.id}`) : undefined}
                        />
                    </Popover>
                );
            })}
        </Flex>
    )
}